<template>
  <v-app>
    <div id="app">
      <router-view/>
    </div>
  </v-app>
</template>

<script>
import { authorize } from '@/services/AuthService';

export default {
  name: 'App',

  beforeMount() {
    this.entryPath = window.location.pathname;
  },

  mounted() {
    this.$router.onReady(() => {
      if (this.entryPath === '/callback') return;

      if (this.entryPath === '/login') {
        authorize('none').catch(() => {
          console.error('Unable to start silent IDP authorization.');
        });
      }
    });
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
